<div class="opt-out-header-container padding-bottom">
    <h3 class="opt-out-header"> OPT OUT OF NOMINATION</h3>
    <div class="opt-out-header-close-btn">
        <button mat-icon-button (click)="closePopup()" class="close-btn font-12">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<hr />
<div class="mobile-pad">
    <div class="opt-out-text">
        <p> You have chosen to opt out of adding a nominee.</p>
        <p>As per SEBI guidelines, please download, sign, and courier the Opt-Out form to complete the process.</p>
    </div>
    <div>
        <p class="font-16 font-bold ">Courier To:</p>
        <div class="address-text" [innerHTML]="address"></div>
    </div>
</div>
<hr/>
<p>
    <strong>You may add a nominee anytime later if you change your decision.</strong>
</p>

<div class="opt-out-buttons flex-centered-container">
    <button type="button" mat-flat-button class="button-container fit-content" color="accent" tabindex="0"
        (click)="downloadForm()">Download Form</button>
    <button type="button" mat-flat-button class="button-container fit-content close-button" tabindex="0"
        (click)="closePopup()">Close</button>
</div>